"use strict";

var sessionId = sessionStorage.getItem('oatSessionId');

/*****************************
 *       Custom ScrollDepth 
 * ***************************/
// Variables to prevent continuous firing of custom events
var scrollTwentyFive    = true;
var scrollFifty         = true;
var scrollSeventyFive   = true;
var scrollOneHundred    = true;

// Create the scrollPercentage
window.addEventListener("scroll",function() {
  window.scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight))* 100;


  // Conditions to fire specific event
  if (window.scrollPercent >= 25 && scrollTwentyFive) {

    scrollTwentyFive = false;
    customScrollDepth(25);

  } else if (window.scrollPercent >= 50 && scrollFifty) {

    scrollFifty = false;
    customScrollDepth(50);

  } else if(window.scrollPercent >= 75 && scrollSeventyFive) {

    scrollSeventyFive = false;
    customScrollDepth(75);

  } else if(window.scrollPercent == 100 && scrollOneHundred) {

    scrollOneHundred = false;
    customScrollDepth(100);
  }

});



/*****************************
 *       VIEW EVENTS
 * ***************************/
//Fire ViewProduct Event on pageload
function viewProduct(product) {

}
//Fire viewHomepage Event on pageload
function viewHomepage() {     
}


//Fire ViewCollection Event on pageload
function viewCollection(collection) {
}


function viewPage(pageTitle, pageURL) { 
}


//Fire ViewArticle Event  on pageload
function viewArticle(article) {
}


//Fire viewSearchResults Event
function viewSearchResults(searchTerm, searchResults, searchType) {
  
}


//Fire viewCart Event 
function viewCart(cart) {
}


//Fire startCheckout Event
function startCheckout() {
}



/*****************************
 *      ADD TO CART EVENT
 * ***************************/
//Add_to_cart Cross Sell Tracking 
function crossSellAdd2Cart(gtagLineItems, value) {

  gtag('event', 'add_to_cart', {
    event_category: "CRO Feature",
    event_label: "crossSellAdd2Cart",
    value: (value / 100),
    currency: "EUR",
    items: gtagLineItems   
  });
}


//Add_to_cart Sticky Tracking 
function stickyAdd2CartFunc(gtagLineItem, value) {

    var lineItem = [{
      item_id:gtagLineItem.id,
      quantity:1
    }];

  
  gtag('event', 'add_to_cart', {
    event_category: "CRO Feature",
    event_label: "stickyAdd2Cart",
    value: (value / 100),
    currency: "EUR",
    items: lineItem
  }); 
}


//Fire Add2Cart Event 
// => when a product gets added to the cart via add2cart button
function add2Cart(variant, currency) {

    var productQuantity = document.querySelector(".quantity__input").value;

    //[Google Analytics]  
    gtag('event', 'add2Cart', {
        product: variant.name,
        sku: variant.sku,
        id: variant.id,
        price: (variant.price / 100),
        currency: currency,
        oat_session_id: sessionId
    });


    //[Klaviyo]
    _learnq.push(['track', 'Added to Cart', item]);
      
}



/*****************************
 *      SCROLL EVENT
 * ***************************/ 
function customScrollDepth(scrollDepth) {

    gtag('event', 'CustomScrollDepth', {
        ScrollDepth: scrollDepth + "%"
      });
}



